import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TooltipContext = /*#__PURE__*/createContext(undefined);
export const TooltipProvider = ({
  iconStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    iconStyleOverrides
  }), [iconStyleOverrides]);
  return /*#__PURE__*/_jsx(TooltipContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the Tooltip component to override icon styles.
 * Note: The context is only available when the Tooltip component is rendered as an ancestor.
 * @returns TooltipContext - The context for tooltip style overrides.
 * @returns TooltipContext.iconStyleOverrides - CSS overrides to apply to icon components within tooltips.
 */
export const useTooltipContext = () => {
  return useContext(TooltipContext);
};